import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  Grid,
  Typography
} from '@mui/material';
import { SlideTransition } from '../../../../components/Transition/Transition';

const CheckboxGridStyle = {
  textAlign: 'center'
};

const AdviserExportWarningDialog = props => {
  const { intl, open, onClose, onConfirm, ...rest } = props;

  const [checked, setChecked] = useState(false);
  const [errors, setErrors] = useState({});

  const onChangeChecked = event => {
    setErrors({});
    setChecked(event.target.checked);
  };

  const formattedOnConfirm = () => {
    if (checked) {
      onConfirm();
      onClose();
    } else {
      setErrors({ checked: intl.formatMessage({ id: 'adviser-export-warning-dialog-checkbox-error' }) });
    }
  };

  const onExited = () => {
    setChecked(false);
    setErrors({});
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      {...rest}
      slots={{
        transition: SlideTransition
      }}
      slotProps={{
        transition: {
          onExited
        }
      }}
    >
      <DialogTitle>{intl.formatMessage({ id: 'adviser-export-warning-dialog-title' })}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ flexDirection: 'column', justifyContent: 'center' }}>
          <Grid>
            <Typography color="textSecondary">
              {intl.formatMessage({ id: 'adviser-export-warning-dialog-content' })}
            </Typography>
          </Grid>
          <Grid style={CheckboxGridStyle}>
            <FormControlLabel
              control={<Checkbox checked={checked} onChange={onChangeChecked} />}
              label={
                <Grid
                  container
                  spacing={1}
                  sx={{
                    alignItems: 'center'
                  }}
                >
                  <Grid>{intl.formatMessage({ id: 'adviser-export-warning-dialog-checkbox-label' })}</Grid>
                  {errors.checked && (
                    <Grid>
                      <FormHelperText error={true}>{errors.checked}</FormHelperText>
                    </Grid>
                  )}
                </Grid>
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" disableElevation={true} onClick={onClose}>
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button onClick={formattedOnConfirm}>{intl.formatMessage({ id: 'Confirm' })}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(AdviserExportWarningDialog);
